import { Star } from '@mui/icons-material'
import { Grid, Tooltip } from '@mui/material'
import React from 'react'
import { getI18n, useTranslation } from 'react-i18next'
import { ILinkedSkill, IWorkHistoryDetailsOther } from '../../../../interfaces/projects/IProjects'
import { OPAccordionItem } from '../../../Accordion/OPAccordionItem'
import { OPNewTable } from '../../../OPcomponents/OPNewTable'
import ProfileWorkHistoryForm from './ProfileWorkHistoryForm'

interface IProps {
  privateWorkHistory: IWorkHistoryDetailsOther[]
  privateWorkHistoryLoading: boolean
  onRowClick: (id: number | string) => Promise<unknown>
  excludeProjectIds?: number[]
}
const ProfilePrivateWorkHistory = ({
  privateWorkHistory,
  privateWorkHistoryLoading,
  onRowClick,
  excludeProjectIds,
}: IProps): JSX.Element => {
  const { t } = useTranslation()
  const filtered = excludeProjectIds?.length
    ? privateWorkHistory.filter((w) => !excludeProjectIds.includes(w.projectId))
    : privateWorkHistory

  const privateWorkHistoryList = filtered.map((work) => {
    return {
      id: work.projectId,
      rows: {
        [t('WorkHistory.EmployerName')]: { text: work.empDetails?.[0]?.name ?? '', width: '20%' },
        [t('Projects.ProjectName')]: { text: work.projectName, width: '20%' },
        [t('WorkHistory.Customer')]: { text: work.customer, width: '20%' },
        [t('WorkHistory.Expirience')]: { text: `${work.daysWorked || 0} ${t('Date.ExperienceDays')}`, width: '10%' },
        [t('Projects.KeyProject')]: {
          text: work.isKeyProject ? <Star color='primary' /> : '',
          width: '9%',
          align: 'center' as const,
        },
        [t('WorkHistory.Skills')]: {
          text: (
            <Tooltip
              title={work.linkedSkills
                .map((s: ILinkedSkill) => (getI18n().language === 'en' && s.skillNameEng?.length ? s.skillNameEng : s.skillNameFi))
                .join(', ')}
              placement='bottom'
              arrow
            >
              <span>{work.linkedSkills.length}</span>
            </Tooltip>
          ),
          width: '10%',
        },
      },
    }
  })

  return (
    <Grid item xs={12}>
      <OPAccordionItem
        title={`${t('WorkHistory.PrivateHeader')} (${privateWorkHistoryLoading ? '\u2026' : filtered.length})`}
        content={
          <Grid container spacing={5} className='gridcontainer--formcontainer__addnewpaddings'>
            <Grid item xs={12}>
              {filtered.length > 0 ? (
                <OPNewTable
                  rows={privateWorkHistoryList}
                  curLength={privateWorkHistoryList.length}
                  onRowClick={onRowClick}
                  FormBase={ProfileWorkHistoryForm}
                />
              ) : (
                <p className='profile--deptext profpadding'>{t('Profile.NoAddedWorkHistoryPrivate')}</p>
              )}
            </Grid>
          </Grid>
        }
      />
    </Grid>
  )
}

export default ProfilePrivateWorkHistory
